const cdnUrl = process.env.CONFIG.cdnUrl.url;
const data = [
  {
    id: 1,
    thumbnail: `${cdnUrl}/giovale-thumbnail.png`,
    original: `${cdnUrl}/giovale-original.jpg`,
  },
  {
    id: 2,
    thumbnail: `${cdnUrl}/gillsans-thumbnail.png`,
    original: `${cdnUrl}/gillsans-original.jpg`,
  },
  {
    id: 3,
    thumbnail: `${cdnUrl}/didonesque-thumbnail.png`,
    original: `${cdnUrl}/didonesque-original.jpg`,
  },
  {
    id: 4,
    thumbnail: `${cdnUrl}/neoSans-thumbnail.png`,
    original: `${cdnUrl}/neoSans-original.jpg`,
  },
  {
    id: 5,
    thumbnail: `${cdnUrl}/justLovely-thumbnail.png`,
    original: `${cdnUrl}/justLovely-original.jpg`,
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/components/Upload/Examples/ExamplesData.js